<template>
  <div class="events-container">
    <div class="events">
      <div class="event" v-for="event in events" :key="event.id">
        <span class="date" v-html="toHumanTime(event.moment)"></span>
        <span>{{ toHumanUserName(event.user_id) }}</span>
        <span>{{ toHumanAction(event) }}</span>
        <span class="data">{{ formatEvent(event) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { sortByDateDescending } from "@/common/utils.sort";
import cache from "@/store/cache";
import eventAction from "@/store/eventAction.js";

export default {
  props: ["card"],
  computed: {
    events() {
      if (!this.card) return [];

      return sortByDateDescending(this.card.events);
    }
  },
  methods: {
    formatEvent(event) {
      if (!event) return "";

      switch (event.action) {
        case eventAction.card.move: {
          const list = cache.lists.byId(event.list_id);
          if (!list) return event.data;

          let msg = 'в лист "' + list.title + '"';
          return msg;
        }
      }

      return event.data;
    },
    toHumanAction(event) {
      const actionInfo = eventAction.getInfo(event.action);
      if (actionInfo) return actionInfo.description;

      return "wtf? " + event.action;
    },
    toHumanUserName(user_id) {
      if (!user_id) return user_id;

      const user = cache.users.byId(user_id);
      if (user) {
        return user.name;
      }

      return user_id;
    },
    toHumanTime(time) {
      if (!time) return time;

      return time.format("DD.MM.YY<br/>HH:mm:ss");
    }
  }
};
</script>
<style>
.events-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  min-height: 60px;
}

.events {
  display: table;
}

.event {
  display: table-row;
}

.event > span {
  padding: 3px;
  display: table-cell;
}

.date {
  word-wrap: unset;
  white-space: nowrap;
}

.data {
  word-wrap: break-word;
  white-space: normal;
  max-width: 200px;
}
</style>
